export default function authCustomerHeader() {
    let user = localStorage.getItem('user');
          if (user && user.token) {
        // return { secret_key: user };
        return { Authorization: 'Bearer ' +  user.token };
    } else {
        return '';
    }
}